

const MarketingIndex = () => {
    return (
        <div className="text-center mt-5">Marketing</div>
    )
}

export default MarketingIndex